/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */
import KeyStateStore from './KeyStateStore';

import ActionTypesCommon from '../constants/ActionTypesCommon';

export default class LocalConfigStore extends KeyStateStore {

    getLocalConfig(key) {
        let v = this.getStateByKey(key);
        if (!v) {
            const vJson = localStorage[ key ];
            v = vJson && JSON.parse(vJson);
            if (v) {
                super.subStateSet(this.getState(), key, v);
            }
        }
        return v;
    }

    getKeyFromAction(action) {
        return action.meta && action.meta.key;
    }

    subStateSet(state, key, subState) {
        let nV = JSON.stringify(subState), oV = localStorage[ key ];
        if (nV !== oV) {
            localStorage[ key ] = nV;
            return super.subStateSet(state, key, subState);
        }
        return state;
    }

    getReducer(action) {
        switch (action.type) {
            case ActionTypesCommon.CONFIG_LOCAL_UPDATE:
                return (state, action) => action.payload;
        }
    }


}




// WEBPACK FOOTER //
// ./js/stores/LocalConfigStore.js